import { memo } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ArrowDownAZ, Clock } from "lucide-react";
import MoneyIcon from "@/components/MoneyIcon";

export type SortOption = "price-asc" | "price-desc" | "time-asc" | "time-desc" | "name-asc" | "name-desc";

interface SortSelectProps {
  value: SortOption;
  onChange: (value: SortOption) => void;
}

export const sortOptions = [
  { value: "price-desc" as const, label: "Preis: Höchster zuerst", icon: MoneyIcon },
  { value: "price-asc" as const, label: "Preis: Niedrigster zuerst", icon: MoneyIcon },
  { value: "time-asc" as const, label: "Zeit: Endet bald", icon: Clock },
  { value: "time-desc" as const, label: "Zeit: Endet später", icon: Clock },
  { value: "name-asc" as const, label: "Name: A-Z", icon: ArrowDownAZ },
  { value: "name-desc" as const, label: "Name: Z-A", icon: ArrowDownAZ },
];

const SortSelect = memo(({ value, onChange }: SortSelectProps) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[200px] bg-secondary/30 border-border/50" aria-label="Sortierung auswählen">
        <SelectValue placeholder="Sortieren nach..." />
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            <span className="flex items-center gap-2">
              <option.icon size={14} className="text-muted-foreground" />
              {option.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

SortSelect.displayName = 'SortSelect';

export default SortSelect;
